export const isOverDue = (dueDate: string) => {
  return new Date().getTime() >= new Date(dueDate).getTime();
};

export const isUpcoming = (dueDate: string) => {
  return new Date().getTime() < new Date(dueDate).getTime();
};
